import { TransitionCover } from '../scenes/TransitionScene';

export default abstract class TransitionBase extends Phaser.GameObjects.Container implements TransitionCover {
  public abstract show(onComplete?: (() => void) | undefined): void;
  public abstract hide(onComplete?: (() => void) | undefined): void;

  protected abstract transitionReset(): void;
  protected abstract transitionIn(onComplete?: () => void): void;
  protected abstract transitionOut(onComplete?: () => void): void;
  protected abstract startTransitionIdle(): void;
  protected abstract stopTransitionIdle(): void;
}
